import { sum } from 'lodash-es';
import { useMemo } from 'react';
import { IconButton } from 'src/components/Buttons';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { flattenListingGroup } from 'src/modals/GroupListings/components/groupingUtils';
import { BroadcastIconInverted } from 'src/svgs';
import { ClockIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Listing, ListingGroup, ListingStatus } from 'src/WebApiController';

import * as styles from './ListingGroupStatusSummary.css';

export const ListingGroupStatusSummary = ({
  listingGroup,
}: {
  listingGroup: ListingGroup;
}) => {
  const flattenedListings = useMemo(
    () => flattenListingGroup(listingGroup),
    [listingGroup]
  );
  return (
    <Stack className={styles.groupStatusIconContainer}>
      <div className={styles.groupStatusIconFirst}>
        <IconButton
          icon={
            <Stack gap="s" alignItems="center">
              <BroadcastIconInverted size={vars.iconSize.m} />
              <span>
                {sum(
                  flattenedListings
                    .filter(
                      (l) =>
                        !l.isLtGrp &&
                        ((l as Listing).status === ListingStatus.Listed ||
                          (l as Listing).status ===
                            ListingStatus.ListingPending)
                    )
                    .map((l) => l.availQty)
                )}
              </span>
            </Stack>
          }
          style={{ padding: '2px 1px' }}
          titleContentId={ContentId.ListingGroupSummaryActiveAndActive}
        />
      </div>
      <div className={styles.groupStatusIconLast}>
        <IconButton
          icon={
            <Stack gap="s" alignItems="center">
              <ClockIcon size={vars.iconSize.m} noOutline />
              <span>
                {sum(
                  flattenedListings
                    .filter(
                      (l) =>
                        !l.isLtGrp &&
                        !(
                          (l as Listing).status === ListingStatus.Listed ||
                          (l as Listing).status === ListingStatus.ListingPending
                        )
                    )
                    .map((l) => l.availQty)
                )}
              </span>
            </Stack>
          }
          style={{ padding: '2px' }}
          titleContentId={ContentId.ListingGroupSummaryQueued}
        />
      </div>
    </Stack>
  );
};
